export const TODOS_TYPES = Object.freeze({
  GET_TODOS_IS_LOADING: '@react-mvp/GET_TODOS_IS_LOADING',
  GET_TODOS_SUCCESSFUL: '@react-mvp/GET_TODOS_SUCCESSFUL',
  GET_TODOS_FAILED: '@react-mvp/GET_TODOS_FAILED',
  GET_TODOS_RESET: '@react-mvp/GET_TODOS_RESET',
});
